export const SKILLS_REQUESTED = 'skills/SKILLS_REQUESTED'
export const  FETCH_SKILLS_REQUESTED   = 'skills/FETCH_SKILLS_REQUESTED'
export const  FETCH_SKILLS_SUCCEED   = 'skills/FETCH_SKILLS_SUCCEED'
export const  FETCH_SKILLS_FAIL     = 'skills/FETCH_SKILLS_FAIL'



// WEBPACK FOOTER //
// ./src/store/skills/actionTypes.js